import { Link } from "react-router-dom";
import moment from "moment";
import React, { PropsWithChildren } from "react";
import { ContentProps } from "../types";
import styles from "./content-empty.module.css";

const Layout: React.FC<PropsWithChildren<{title: string}>> = ({ title, children }) => <div style={{ textAlign: "center" }}>
  <br />
  <span className={styles.heading}>{title}</span>
  <br />
  <span>
    {children}
  </span>
  <br />
  <br />
</div>;

const Empty: React.FC<ContentProps> = props => {
  const {
    interestList: {
      scheduledUpdate: { enabled, begins },
    },
  } = props;

  if (!enabled) {
    return (<Layout title="List updates are not enabled.">
      Enable updates in the{" "}
      <Link to="/dash/manager/settings/scheduled-updates">list update settings</Link> page.
    </Layout>
    );
  }

  return (<Layout title="The list update has not yet started">
    The next scheduled list update begins on{" "}
    <strong>{moment.utc(begins).format("MMMM D, YYYY")}</strong>
  </Layout>
  );
};

export default Empty;
